import { Fragment } from "react";

import { useHistory } from "react-router-dom";
import { Cell, Pie, PieChart } from "recharts";

import EditIcon from "@material-ui/icons/Edit";

import { useNewSubscriberContext } from "../../Context/NewSubsciberContext";
import { setOldAccountType } from "../../Context/NewSubscriberAction";
import { Box, Typography } from "@material-ui/core";
import CardComponent2 from "../../../transactions/newInvestor/lib/CardComponent2";
import { SummaryCard } from "../../../transactions/newInvestor/lib/CardComponent2";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];
const LABELS = {
  E: "Equity",
  C: "Corp Bonds",
  G: "Govt Sec",
  A: "Alternate Investment Funds",
};

const labelText = {
  fontSize: "14px",
  fontWeight: 400,
  color: "#002856",
  lineHeight: "16px",
};

const bodyText = {
  fontSize: "14px",
  fontWeight: 400,
  color: "#000000",
  lineHeight: "16px",
};

const SchemeDetailsPreview = () => {
  // const { npsSchemeDetails = {} } = useSelector((state) => state.newSubscriber);

  // const { schemeDetailsPreview = {} } = useSelector(
  //   (state) => state.newSubscriber.preview
  // );

  // const { SchemeDetailsList = {}, SchemeDetailsList2 = {} } =
  //   schemeDetailsPreview;
  const history = useHistory();
  const {
    schemeDetails,
    dispatch: contextDispatch,
    accountType,
  } = useNewSubscriberContext();

  const {
    TierTwoInvestmentChoice,
    TierOneInvestmentChoice,
    TierOneFundCodeOptedDes,
    contribution_amount,
    AccountType,
    contribution_amountT2,
    TierTwoFundCodeOptedDes,
  } = schemeDetails.data;
  const back = () => {
    setOldAccountType(accountType?.data?.AccountType)(contextDispatch);
    history.push({
      pathname: "/nps/AddSubs/scheme-details",
    });
  };
  return (
    <Fragment>
      <div className="new-subscriber-container">
        <div
          style={{
            paddingLeft: "16px",
            fontSize: "18px",
            color: "#000000",
            fontWeight: "400",
            opacity: "0.8",
            paddingBottom: "4px",
          }}
        >
          SCHEME DETAILS
        </div>
        <EditIcon className="cursor" onClick={back} />
      </div>
      <SummaryCard title="TIER I">
        <Box
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gridRowGap: "2rem",
            padding: "20px 6px 20px 6px",
            margin: "0px 5px 20px 8px",
          }}
        >
          <div>
            <Typography style={labelText}>Account Type</Typography>
            <Typography style={bodyText}>{"Tier I"}</Typography>
          </div>
          <div>
            <Typography style={labelText}>Investment Options</Typography>
            <Typography style={bodyText}>
              {TierOneInvestmentChoice === 1 ? "Active" : "Auto"}
            </Typography>
          </div>
          <div>
            <Typography style={labelText}>Pension Funds</Typography>
            <Typography style={bodyText}>{TierOneFundCodeOptedDes}</Typography>
          </div>
          <div>
            <Typography style={labelText}>Contribution Amount</Typography>
            <Typography style={bodyText}>₹{contribution_amount}</Typography>
          </div>
        </Box>
      </SummaryCard>

      {AccountType === "2" && (
        <>
          <SummaryCard title="TIER II">
            <Box
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gridRowGap: "2rem",
                padding: "20px 6px 20px 6px",
                margin: "0px 5px 20px 8px",
              }}
            >
              <div>
                <Typography style={labelText}>Account Type</Typography>
                <Typography style={bodyText}>{"Tier II"}</Typography>
              </div>
              <div>
                <Typography style={labelText}>Investment Options</Typography>
                <Typography style={bodyText}>
                  {TierTwoInvestmentChoice === 1 ? "Active" : "Auto"}
                </Typography>
              </div>
              <div>
                <Typography style={labelText}>Pension Funds</Typography>
                <Typography style={bodyText}>
                  {TierTwoFundCodeOptedDes}
                </Typography>
              </div>
              <div>
                <Typography style={labelText}>Contribution Amount</Typography>
                <Typography style={bodyText}>
                  ₹{contribution_amountT2}
                </Typography>
              </div>
            </Box>
          </SummaryCard>
        </>
      )}
      {/* <div className="grid-responsive">
        <p>
          <b>NPS Account Tier</b>
        </p>
        <p>Tier - {npsSchemeDetails?.data?.AccountType || "1"}</p>
      </div> */}

      {/* <div className="flex-nps">
        <Tier1SchemeDetails schemeDetails={npsSchemeDetails.data} />
        <PieChartContainer schemeDetailsArray={SchemeDetailsList} tier="I" />
      </div> */}

      {/* {+npsSchemeDetails?.data?.AccountType === 2 && (
        <Fragment>
          <div
            style={{
              marginTop: "20px",
              borderTopStyle: "dashed",
              borderTopColor: "lightgray",
              borderTopWidth: "2px",
            }}
          />
          <div className="flex-nps">
            <Tier2SchemeDetails schemeDetails={npsSchemeDetails.data} />
            <PieChartContainer
              schemeDetailsArray={SchemeDetailsList2}
              tier="II"
            />
          </div>
        </Fragment>
      )} */}
    </Fragment>
  );
};
export default SchemeDetailsPreview;

const PieChartContainer = ({ schemeDetailsArray, tier }) => {
  return (
    <div>
      <h4 className="sub-header">Tier {tier} Percentage Allocation</h4>
      <div className="nps-pie-chart-container">
        <PieChart width={450} height={200}>
          <Pie
            fill="#8884d8"
            data={schemeDetailsArray}
            dataKey="Percentage"
            nameKey="Percentage"
          >
            {schemeDetailsArray.map((entry, index) => {
              return (
                <Cell
                  name={entry.AssetCategory}
                  key={index}
                  fill={COLORS[index]}
                />
              );
            })}
          </Pie>
        </PieChart>
        <div className="nps-pie-chart-legend">
          {schemeDetailsArray.map((entry, index) => (
            <div style={{ display: "flex" }} key={index}>
              {entry.Percentage !== 0 && (
                <Fragment>
                  <div
                    style={{
                      backgroundColor: COLORS[index] || "red",
                      height: 5,
                      marginTop: 4,
                      width: 5,
                      padding: 5,
                    }}
                  />
                  <span>
                    {LABELS[entry.AssetCategory]} - {entry.Percentage}%
                  </span>
                </Fragment>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const Tier1SchemeDetails = ({ schemeDetails }) => {
  return (
    <div>
      <h4 className="sub-header">Tier I Scheme Details</h4>
      <div className="grid-responsive-scheme-details">
        <p>
          <b>Pension Fund Manager</b>
        </p>
        <p>{schemeDetails?.TierOneFundCodeOptedDes}</p>
        <p>
          <b>Contribution Amount</b>
        </p>

        <p>₹{schemeDetails?.contribution_amount}</p>
        <p>
          <b>Investmment Option</b>
        </p>
        <p>
          {+schemeDetails?.TierOneInvestmentChoice === 1
            ? "Active Investment"
            : "Auto Investment"}
        </p>
      </div>
    </div>
  );
};

const Tier2SchemeDetails = ({ schemeDetails }) => {
  return (
    <div>
      <h4 className="sub-header">Tier II Scheme Details</h4>
      <div className="grid-responsive-scheme-details">
        <p>
          <b> Pension Fund Manager</b>
        </p>
        <p>{schemeDetails.TierTwoFundCodeOptedDes}</p>
        <p>
          <b> Contribution Amount</b>
        </p>
        <p>₹{schemeDetails.contribution_amountT2}</p>
        <p>
          <b> Investmment Option</b>
        </p>
        <p>
          {+schemeDetails.TierTwoInvestmentChoice === 1
            ? "Active Investment"
            : "Auto Investment"}
        </p>
      </div>
    </div>
  );
};
